import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './InformationMessage.css';

const InformationMessage = ({ title, message }) => {

  const ValidateMessage = (messageContent) => {
    return messageContent?.trim().length > 0;
  };
  
  if (!ValidateMessage(title) || !ValidateMessage(message)) {
    return null; 
  }

  return (
    <Box
      sx={{
        width: '100%',
        margin: '0 0 16px 0',
        
        boxSizing: 'border-box',
      }}
    >
      <Accordion
        defaultExpanded
        square={true}
        sx={{
          borderRadius: '1.5em', // Increased border radius to 1.5em
          overflow: 'hidden', // Ensures that the rounded borders are respected
          boxShadow: 'var(--boxShadow)', // Uses the CSS variable
          '&:before': {
            display: 'none', // Removes the default line before the Accordion
          },
          backgroundColor: 'var(--light-yellow)', // Applies the desired background color
          // Style AccordionSummary
          '& .MuiAccordionSummary-root': {
            backgroundColor: 'var(--light-yellow)', // Background of the summary
            borderTopLeftRadius: '1.5em', // Rounds the top-left corners
            borderTopRightRadius: '1.5em',
          },
          // Style AccordionDetails
          '& .MuiAccordionDetails-root': {
            backgroundColor: 'var(--light-yellow)', // Background of the content
            borderBottomLeftRadius: '1.5em', // Rounds the bottom-left corners
            borderBottomRightRadius: '1.5em',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="information-message-content"
          id="information-message-header"
        >
          <Typography
            variant="subtitle1"
            sx={{
              flexGrow: 1,
              wordWrap: 'break-word',
              color: 'var(--orange)', // Title in orange
              fontWeight: 600, // Font-weight 600
              fontFamily: 'Open Sans, sans-serif', // Custom font
              fontSize: '1.25rem', // Font size
              letterSpacing: '0.01071em', // Letter spacing
              lineHeight: 'normal',
              margin: 0,
              boxSizing: 'inherit',
              WebkitFontSmoothing: 'antialiased', // Adjustment for font-smoothing
            }}
          >
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            variant="body2"
            sx={{
              color: 'black', // Subtext in black
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              fontFamily: 'Open Sans, sans-serif', // Custom font for subtext
              fontWeight: 400, // Font-weight 400 (can adjust if necessary)
              fontSize: '0.875rem', // Font size p2
              letterSpacing: '0.01071em',
              lineHeight: 'normal',
            }}
          >
            {message}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default InformationMessage;